var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_2",
    "data-name": "Calque 2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 710.71 214.12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: url(#D\xE9grad\xE9_sans_nom_175);\n      }\n\n      .cls-1, .cls-2, .cls-3 {\n        stroke-width: 0px;\n      }\n\n      .cls-2 {\n        fill: url(#D\xE9grad\xE9_sans_nom_196);\n      }\n\n      .cls-3 {\n        fill: #233c7b;\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_196",
    "data-name": "D\\xE9grad\\xE9 sans nom 196",
    x1: 439.98,
    y1: 8.27,
    x2: 482.87,
    y2: 51.17,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#047ec2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#067abf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#0d6eb6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#185ba8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#294195"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#392782"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_175",
    "data-name": "D\\xE9grad\\xE9 sans nom 175",
    x1: 0,
    y1: 121.92,
    x2: 651.62,
    y2: 121.92,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#243b7e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#223e81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#1c498c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#125b9f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#0475ba"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#007ec3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#1060a2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#243c7c"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Calque_1-2",
    "data-name": "Calque 1"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-2",
    cx: 461.43,
    cy: 29.72,
    rx: 30.93,
    ry: 29.72
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m658.64,76.78c0-15.46,8.32-25.84,26.03-25.84s26.03,10.39,26.03,25.84-8.2,25.97-26.03,25.97-26.03-10.51-26.03-25.97Zm45.05,0c0-11.76-5.44-19.4-19.02-19.4s-19.02,7.63-19.02,19.4,5.32,19.52,19.02,19.52,19.02-7.82,19.02-19.52Zm-19.27,4.44h-4.19v7.95h-7.2v-24.97h13.02c6.88,0,10.51,2.88,10.51,8.7,0,3.88-1.94,6.38-5.32,7.57l6.38,8.45v.25h-8.07l-5.13-7.95Zm-4.19-10.95v5.82h5.44c2.5,0,3.69-.94,3.69-2.88,0-2.06-1.13-2.94-3.81-2.94h-5.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m487.34,118.43s0-.01,0-.04c-.03-.86.23-1.57.66-2.13,1.43-1.89,4.78-1.94,5.91.74l29.59,70.44c2.58,6.56,6.65,12.16,11.72,16.49,7.12,6.08,16.21,9.63,26.03,9.63h1.04c16.8,0,31.53-10.34,37.74-26.11l51.6-123.98-25.22.15c-17.85.1-33.94,10.82-40.9,27.26l-21.56,50.87c-.71,1.68-3.11,1.66-3.79-.04l-21.06-52.18c-6.4-15.22-20.65-23.74-37.54-25.66-3.98-.43-7.32-.52-10.51-.54-2.47-.01-4.88.74-6.9,2.15-3,1.88-6.24,3.43-9.66,4.62-2.62.91-5.36,1.58-8.16,2.05l.07.02c-5.99,1.01-12.2-.11-17.86-2.05-3.42-1.19-6.65-2.74-9.66-4.62-2.02-1.41-4.43-2.16-6.9-2.15-3.19.01-6.53.11-10.51.54-8.01.87-14.81,2.99-20.18,6.43-6.16,3.94-10.84,9.82-13.71,16.54l-23.66,55.39c-.58,1.37-2.25,1.58-3.22.73-.25-.22-.47-.49-.6-.85l-21.22-54.63c-4.58-12.59-16.79-18.38-30.37-18.38h0c-1.69,0-3.36.09-4.99.27-11.11,1.23-20.66,6.71-24.92,17-.15.37-.32.72-.46,1.11l-21.32,54.91c-.59,1.66-2.91,1.73-3.6.11l-37.58-78.89c-8.69-20.49-20.57-33.84-42.81-33.92h-93.36c-3.9,0-7.73.36-11.46,1.1-23.3,4.4-42,22.39-46.83,45.5-.1.45-.18.91-.26,1.37-.07.36-.14.72-.2,1.08-.52,3.07-.81,6.21-.81,9.41-.01,14.65,5.4,28.07,14.32,38.36l.02.02c10.71,12.2,26.61,19.92,44.07,19.92h48.54c2.06,0,4.08.78,5.47,2.3,4,4.38.26,10.66-4.53,10.66l-49.51-.02h-25.85c-28.94,0-52.4,23.44-52.43,52.38l129.56.05c31.41,0,57.95-24.36,59.43-55.73,1.25-26.41-15.14-49.27-38.37-57.8-6.37-2.39-13.25-3.71-20.44-3.71h-48.33c-1.85,0-3.67-.65-5.01-1.91-4.4-4.43-.6-10.96,4.3-10.96h72.34s9.2.01,9.2.01c5.49,0,10.43,3.33,12.51,8.4l43.54,101.23c5.49,13.95,21.5,22.74,36.23,22.74h.78c14.72,0,27.78-9.02,33.28-22.99l17.05-43.92c.87-2.23,4.03-2.23,4.9,0l17.05,43.92c3.78,9.6,11.12,16.86,20.13,20.46,3.93,1.28,8.11,1.97,12.42,1.97h1.92c4.31,0,8.49-.69,12.42-1.97,9-3.6,15.73-10.79,20.17-20.51h0s33.86-74.08,33.86-74.08c.15-.36.35-.66.57-.92,1.43-1.7,4.1-1.45,5.33.18.42.56.68,1.27.66,2.13,0,.03,0,.04,0,.04l.02.27-.02,83.75c0,9.09,5.06,10.29,12.51,10.15,3.36-.08,7.21-.41,11.29-.41h4.28c4.08,0,7.93.34,11.29.41,7.46.14,12.51-1.05,12.51-10.15l-.02-83.54v-.49Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.039d530fa36efd9509994d66845b6880.svg";
export { ForwardRef as ReactComponent };